import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  timeout: 15000,
  withCredentials: true,
});

export const getCategories = () => api.get("/categories").then((r) => r.data);
export const getCampaigns = () => api.get("/campaigns").then((r) => r.data);
export const getProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const getCollections = () => api.get("/collections").then((r) => r.data);
export const getCollection = (slug) => api.get(`/collections/${slug}`).then((r) => r.data);
export const getLocations = (params = {}) => api.get("/locations", { params }).then((r) => r.data);
export const postSubscriber = (payload) => api.post("/subscribers", payload).then((r) => r.data);
export const postLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const postContact = (payload) => api.post("/contact", payload).then((r) => r.data);

export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const getServerFavorites = () => api.get("/auth/favorites").then((r) => r.data);
export const putServerFavorites = (favorites) => api.put("/auth/favorites", { favorites }).then((r) => r.data);
export const forgotPassword = (email) => api.post("/auth/forgot-password", { email }).then((r) => r.data);
export const resetPassword = (payload) => api.post("/auth/reset-password", payload).then((r) => r.data);
export const getMyOrders = () => api.get("/orders").then((r) => r.data);
export const getAddresses = () => api.get("/auth/addresses").then((r) => r.data);
export const addAddress = (payload) => api.post("/auth/addresses", payload).then((r) => r.data);
export const deleteAddress = (id) => api.delete(`/auth/addresses/${id}`).then((r) => r.data);
export const getAdminOverview = () => api.get("/admin/overview").then((r) => r.data);
export const getAdminOrders = () => api.get("/admin/orders").then((r) => r.data);
export const getAdminLeads = () => api.get("/admin/leads").then((r) => r.data);
export const getAdminSubscribers = () => api.get("/admin/subscribers").then((r) => r.data);
export const getAdminMessages = () => api.get("/admin/messages").then((r) => r.data);
export const getAdminProducts = () => api.get("/admin/products").then((r) => r.data);
export const patchAdminProduct = (slug, payload) => api.patch(`/admin/products/${slug}`, payload).then((r) => r.data);
export const getAdminCampaigns = () => api.get("/admin/campaigns").then((r) => r.data);
export const createCampaign = (payload) => api.post("/admin/campaigns", payload).then((r) => r.data);
export const updateCampaign = (slug, payload) => api.put(`/admin/campaigns/${slug}`, payload).then((r) => r.data);
export const deleteCampaign = (slug) => api.delete(`/admin/campaigns/${slug}`).then((r) => r.data);
export const uploadProductImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/admin/upload", fd).then((r) => r.data);
};
export const refundOrder = (sessionId) => api.post(`/admin/orders/${sessionId}/refund`).then((r) => r.data);
export const patchOrderStatus = (sessionId, fulfillment_status) =>
  api.patch(`/admin/orders/${sessionId}`, { fulfillment_status }).then((r) => r.data);
export const markOrderPaid = (sessionId) =>
  api.patch(`/admin/orders/${sessionId}`, { mark_paid: true }).then((r) => r.data);
export const fileUrl = (path) => `${process.env.REACT_APP_BACKEND_URL}/api/files/${path}`;
export const createCheckout = (payload) => api.post("/payments/checkout", payload).then((r) => r.data);
export const getPaymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`).then((r) => r.data);

export const formatPrice = (n) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n);

export function formatApiError(err) {
  const data = err?.response?.data;
  const detail = data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof data === "string" && data.includes("<")) return "İstek şu an tamamlanamadı, lütfen tekrar dene";
  return err?.message || "Bir sorun oluştu, tekrar dene";
}

export default api;
